import type {
  AddFavoritoInput,
  Favorito,
  ListFavoritosFilter,
  ListFavoritosResponse,
} from '@lance-x/shared';
import type { ApiClient } from '../index';

/**
 * Phase 26 — Catálogo de favoritos (REQ-CATALOGO-01).
 *
 * Empresa-side REST surface for the favorito catálogo:
 *   - GET    /empresa/equipe-profissionais             — list with filters
 *   - POST   /empresa/equipe-profissionais             — manual add
 *   - DELETE /empresa/equipe-profissionais/:profId     — remove (idempotent)
 *
 * Auto-add via candidatura-aprovada hook is server-side; no client endpoint.
 */
export class CatalogoEndpoints {
  constructor(private readonly client: ApiClient) {}

  listar(filter?: Partial<ListFavoritosFilter>): Promise<ListFavoritosResponse> {
    const query: Record<string, string | number | undefined> = {};
    if (filter?.status) query['status'] = filter.status;
    if (filter?.minRating !== undefined) query['minRating'] = filter.minRating;
    if (filter?.verificadoOnly !== undefined) {
      query['verificadoOnly'] = String(filter.verificadoOnly);
    }
    if (filter?.page !== undefined) query['page'] = filter.page;
    if (filter?.limit !== undefined) query['limit'] = filter.limit;
    return this.client.get<ListFavoritosResponse>(
      '/empresa/equipe-profissionais',
      { query },
    );
  }

  adicionar(input: AddFavoritoInput): Promise<Favorito> {
    return this.client.post<Favorito>('/empresa/equipe-profissionais', input);
  }

  remover(profissionalId: string): Promise<{ removed: boolean }> {
    return this.client.delete<{ removed: boolean }>(
      `/empresa/equipe-profissionais/${profissionalId}`,
    );
  }
}
